/*
 * @Author: leventlei
 * @Date: 2024-03-24 11:45:19
 * @LastEditTime: 2025-01-09 13:36:32
 * @LastEditors: leventlei
 * @Description:富文本编辑器
 * @FilePath: /IOT4CMS/src/components/MyRichTextEditor/index.tsx
 */
import React, { FC, useEffect, useState } from 'react'
import getHeaders from '@/utils/signature'

import {
	// DomEditor,
	IDomEditor,
	IEditorConfig,
	IToolbarConfig,
} from '@wangeditor/editor'
import { Editor, Toolbar } from '@wangeditor/editor-for-react'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
// import { Button } from 'antd'
import ss from './index.less'

interface MyRichTextEditorProps {
	defaultHtml: string // 默认内容
	placeholder?: string //placeholder
	onHtmlChange: (html: string) => void // 内容变化时触发
}

const MyRichTextEditor: FC<MyRichTextEditorProps> = ({
	defaultHtml,
	placeholder,
	onHtmlChange,
}) => {
	const [renderDefaultHtml, setRenderDefaultHtml] = useState<boolean>(false) // 是否已初始渲染默认内容
	const [editor, setEditor] = useState<IDomEditor | null>(null) // editor 实例
	const [html, setHtml] = useState<string>('') // 编辑器内容
	const { Authorization, echostr, nonce, signature, timestamp } = getHeaders()

	/* 初始渲染默认内容 */
	useEffect(() => {
		if (!defaultHtml || renderDefaultHtml) return
		setHtml(defaultHtml)
		setRenderDefaultHtml(true)
	}, [])
	/* 及时销毁 editor ，重要！ */
	useEffect(() => {
		return () => {
			if (editor == null) return
			editor.destroy()
			setEditor(null)
		}
	}, [editor])

	/* 工具栏配置 */
	const toolbarConfig: Partial<IToolbarConfig> = {
		// excludeKeys: ['headerSelect', 'blockquote', 'uploadImage', 'uploadVideo'],
		excludeKeys: ['headerSelect', 'blockquote', 'uploadVideo'],
	}

	/* 编辑器配置 */
	const editorConfig: Partial<IEditorConfig> = {
		placeholder: placeholder ?? '请输入展览详情（该字段会在前端展示）',
		maxLength: 1000,
		MENU_CONF: {},
	}
	// @ts-ignore
	editorConfig.MENU_CONF['uploadImage'] = {
		server: 'https://fengtuzhi.com/api/hotel-manager/file/uploadFileToRichText',
		timeout: 5 * 1000, // 5s

		fieldName: 'file',
		// meta: { token: 'console-46e21ca3-bdd5-43c3-883c-ab4f72523aeb', a: 100 },
		metaWithUrl: true, // join params to url
		headers: {
			Accept: 'application/json; charset=utf-8',
			Authorization: Authorization,
			echostr: echostr,
			nonce: nonce,
			signature: signature,
			timestamp: timestamp,
			device: 'pc',
		},
		maxFileSize: 10 * 1024 * 1024, // 10M
		base64LimitSize: 5 * 1024, // insert base64 format, if file's size less than 5kb

		// 上传之前触发
		onBeforeUpload(file: File) {
			// file 选中的文件，格式如 { key: file }
			console.log('on file:', file)
			return file

			// 可以 return
			// 1. return file 或者 new 一个 file ，接下来将上传
			// 2. return false ，不上传这个 file
		},

		// 上传进度的回调函数
		onProgress(progress: number) {
			// progress 是 0-100 的数字
			console.log('progress', progress)
		},

		// 单个文件上传成功之后
		onSuccess(file: File, res: any) {
			console.log(`${file.name} 上传成功`, res)
		},

		// 单个文件上传失败
		onFailed(file: File, res: any) {
			console.log(`${file.name} 上传失败`, res)
		},

		// 上传错误，或者触发 timeout 超时
		onError(file: File, err: any, res: any) {
			console.log(`${file.name} 上传出错`, err, res)
		},
	}

	return (
		<div className={ss.myRichTextEditor}>
			<div style={{ border: '1px solid #ccc', zIndex: 100 }}>
				<Toolbar
					editor={editor}
					defaultConfig={toolbarConfig}
					mode="default"
					style={{ borderBottom: '1px solid #ccc' }}
				/>
				<Editor
					defaultConfig={editorConfig}
					value={html}
					onCreated={setEditor}
					onChange={editor => {
						setHtml(editor.getHtml())
						onHtmlChange(editor.getHtml())
					}}
					mode="default"
					style={{ height: '150px', overflowY: 'hidden' }}
				/>
			</div>
			{/* <Button
				type="primary"
				onClick={() => {
					let toolbar = DomEditor.getToolbar(editor!)
					let shit = toolbar?.getConfig().toolbarKeys
					console.log(shit)
				}}
			>
				查看工具栏设置
			</Button> */}
			{/* <div style={{ marginTop: '15px' }}>{html}</div> */}
		</div>
	)
}

export default MyRichTextEditor
